export { default as MaterialsIndexPageCategoriesNavList } from './MaterialsIndexPageCategoriesNavList';
